import { useRef } from 'react';

export default function ResizeHandle({ rightPanelWidth, onResize }) {
  const dragging = useRef(false);
  const start = useRef({ x: 0, width: 0 });

  const onMouseDown = (e) => {
    e.preventDefault();
    dragging.current = true;
    start.current = { x: e.clientX, width: rightPanelWidth };

    const onMove = (e) => {
      if (!dragging.current) return;
      // Dragging left increases panel width
      const dx = start.current.x - e.clientX;
      const w = Math.min(
        Math.max(280, start.current.width + dx),
        Math.round(window.innerWidth * 0.65)
      );
      onResize(w);
    };

    const onUp = () => {
      dragging.current = false;
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  };

  return (
    <div
      className="hidden md:flex flex-shrink-0 w-1.5 bg-gray-700 hover:bg-blue-500 active:bg-blue-600 cursor-col-resize transition-colors z-10"
      onMouseDown={onMouseDown}
      title="Drag to resize"
    />
  );
}
